export type VoucherType = 'Hotel' | 'Transfer' | 'Tour' | 'Flight' | 'Activity' | 'Cruise';
export type VoucherStatus = 'Active' | 'Used' | 'Cancelled' | 'Expired';

export interface Voucher {
  id: string;
  number: string;
  bookingId: string;
  type: VoucherType;
  status: VoucherStatus;
  customer: string;
  customerAvatar: string;
  customerEmail: string;
  customerPhone: string;
  pax: number;
  travelDate: string;
  endDate: string;
  issuedDate: string;
  destination: string;
  agent: string;
  supplierName: string;
  supplierAddress: string;
  supplierPhone: string;
  supplierEmail: string;
  supplierRef: string;
  serviceTitle: string;
  serviceDetails: string[];
  checkIn?: string;
  checkOut?: string;
  roomType?: string;
  mealPlan?: string;
  pickupLocation?: string;
  dropoffLocation?: string;
  pickupTime?: string;
  vehicleType?: string;
  tourName?: string;
  tourGuide?: string;
  meetingPoint?: string;
  confirmationCode: string;
  specialInstructions: string;
}

export const vouchersData: Voucher[] = [];

export const voucherTypeColors: Record<string, string> = {
  Hotel: '#0D9488',
  Transfer: '#7C3AED',
  Tour: '#D97706',
  Flight: '#2563EB',
  Activity: '#DC2626',
  Cruise: '#0891B2',
};

export const voucherTypeIcons: Record<string, string> = {
  Hotel: 'ri-hotel-line',
  Transfer: 'ri-car-line',
  Tour: 'ri-map-2-line',
  Flight: 'ri-flight-takeoff-line',
  Activity: 'ri-ticket-line',
  Cruise: 'ri-ship-line',
};
